/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Artic
 * The Artic API documentation
 * OpenAPI spec version: 1.0
 */
import {
  useMutation,
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query';

import type {
  CapacityMatrixResponseDto,
  ProductionPlanControllerGetCapacityMatrixParams,
  ProductionPlanControllerGetSummaryParams,
  ProductionPlanSummaryResponseDto,
  ProductionPlannerControllerListPartnerProductionPlannerParams,
  ProductionPlannerPageDto,
  RescheduleApplyRequestDto,
  ReschedulePreviewRequestDto,
  RescheduleResponseDto,
  WorkOrderAtRiskReasonsResponseDto,
  WorkOrderPlanResponseDto
} from '../schemas';

import { customFetch } from '../../custom-fetch.ts';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export type productionPlannerControllerListPartnerProductionPlannerResponse200 = {
  data: ProductionPlannerPageDto
  status: 200
}

export type productionPlannerControllerListPartnerProductionPlannerResponse400 = {
  data: void
  status: 400
}

export type productionPlannerControllerListPartnerProductionPlannerResponse401 = {
  data: void
  status: 401
}

export type productionPlannerControllerListPartnerProductionPlannerResponse403 = {
  data: void
  status: 403
}

export type productionPlannerControllerListPartnerProductionPlannerResponseSuccess = (productionPlannerControllerListPartnerProductionPlannerResponse200) & {
  headers: Headers;
};
export type productionPlannerControllerListPartnerProductionPlannerResponseError = (productionPlannerControllerListPartnerProductionPlannerResponse400 | productionPlannerControllerListPartnerProductionPlannerResponse401 | productionPlannerControllerListPartnerProductionPlannerResponse403) & {
  headers: Headers;
};

export type productionPlannerControllerListPartnerProductionPlannerResponse = (productionPlannerControllerListPartnerProductionPlannerResponseSuccess | productionPlannerControllerListPartnerProductionPlannerResponseError)

export const getProductionPlannerControllerListPartnerProductionPlannerUrl = (partnerId: string,
    params?: ProductionPlannerControllerListPartnerProductionPlannerParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/partners/${partnerId}/production-planner?${stringifiedParams}` : `/partners/${partnerId}/production-planner`
}

/**
 * Returns a deterministic page of non-archived work orders for the partner with matching priority rows first. The response carries the full population and priority counts. Wide schedule joins, container selections, and Production Plan enrichment are scoped to the returned page.
 * @summary Production planner: partner-wide work orders with tracking fields
 */
export const productionPlannerControllerListPartnerProductionPlanner = async (partnerId: string,
    params?: ProductionPlannerControllerListPartnerProductionPlannerParams, options?: Parameters<typeof customFetch>[1]): Promise<productionPlannerControllerListPartnerProductionPlannerResponse> => {

  return customFetch<productionPlannerControllerListPartnerProductionPlannerResponse>(getProductionPlannerControllerListPartnerProductionPlannerUrl(partnerId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getProductionPlannerControllerListPartnerProductionPlannerQueryKey = (partnerId: string,
    params?: ProductionPlannerControllerListPartnerProductionPlannerParams,) => {
    return [
    `/partners/${partnerId}/production-planner`, ...(params ? [params] : [])
    ] as const;
    }


export const getProductionPlannerControllerListPartnerProductionPlannerQueryOptions = <TData = Awaited<ReturnType<typeof productionPlannerControllerListPartnerProductionPlanner>>, TError = void>(partnerId: string,
    params?: ProductionPlannerControllerListPartnerProductionPlannerParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof productionPlannerControllerListPartnerProductionPlanner>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getProductionPlannerControllerListPartnerProductionPlannerQueryKey(partnerId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof productionPlannerControllerListPartnerProductionPlanner>>> = ({ signal }) => productionPlannerControllerListPartnerProductionPlanner(partnerId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: partnerId !== null && partnerId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof productionPlannerControllerListPartnerProductionPlanner>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ProductionPlannerControllerListPartnerProductionPlannerQueryResult = NonNullable<Awaited<ReturnType<typeof productionPlannerControllerListPartnerProductionPlanner>>>
export type ProductionPlannerControllerListPartnerProductionPlannerQueryError = void


export function useProductionPlannerControllerListPartnerProductionPlanner<TData = Awaited<ReturnType<typeof productionPlannerControllerListPartnerProductionPlanner>>, TError = void>(
 partnerId: string,
    params: undefined |  ProductionPlannerControllerListPartnerProductionPlannerParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof productionPlannerControllerListPartnerProductionPlanner>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof productionPlannerControllerListPartnerProductionPlanner>>,
          TError,
          Awaited<ReturnType<typeof productionPlannerControllerListPartnerProductionPlanner>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useProductionPlannerControllerListPartnerProductionPlanner<TData = Awaited<ReturnType<typeof productionPlannerControllerListPartnerProductionPlanner>>, TError = void>(
 partnerId: string,
    params?: ProductionPlannerControllerListPartnerProductionPlannerParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof productionPlannerControllerListPartnerProductionPlanner>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof productionPlannerControllerListPartnerProductionPlanner>>,
          TError,
          Awaited<ReturnType<typeof productionPlannerControllerListPartnerProductionPlanner>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useProductionPlannerControllerListPartnerProductionPlanner<TData = Awaited<ReturnType<typeof productionPlannerControllerListPartnerProductionPlanner>>, TError = void>(
 partnerId: string,
    params?: ProductionPlannerControllerListPartnerProductionPlannerParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof productionPlannerControllerListPartnerProductionPlanner>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Production planner: partner-wide work orders with tracking fields
 */

export function useProductionPlannerControllerListPartnerProductionPlanner<TData = Awaited<ReturnType<typeof productionPlannerControllerListPartnerProductionPlanner>>, TError = void>(
 partnerId: string,
    params?: ProductionPlannerControllerListPartnerProductionPlannerParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof productionPlannerControllerListPartnerProductionPlanner>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getProductionPlannerControllerListPartnerProductionPlannerQueryOptions(partnerId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Production planner: partner-wide work orders with tracking fields
 */
export const prefetchProductionPlannerControllerListPartnerProductionPlannerQuery = async <TData = Awaited<ReturnType<typeof productionPlannerControllerListPartnerProductionPlanner>>, TError = void>(
 queryClient: QueryClient, partnerId: string,
    params?: ProductionPlannerControllerListPartnerProductionPlannerParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof productionPlannerControllerListPartnerProductionPlanner>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getProductionPlannerControllerListPartnerProductionPlannerQueryOptions(partnerId,params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}





export const getProductionPlannerControllerListPartnerProductionPlannerSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof productionPlannerControllerListPartnerProductionPlanner>>, TError = void>(partnerId: string,
    params?: ProductionPlannerControllerListPartnerProductionPlannerParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof productionPlannerControllerListPartnerProductionPlanner>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getProductionPlannerControllerListPartnerProductionPlannerQueryKey(partnerId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof productionPlannerControllerListPartnerProductionPlanner>>> = ({ signal }) => productionPlannerControllerListPartnerProductionPlanner(partnerId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof productionPlannerControllerListPartnerProductionPlanner>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ProductionPlannerControllerListPartnerProductionPlannerSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof productionPlannerControllerListPartnerProductionPlanner>>>
export type ProductionPlannerControllerListPartnerProductionPlannerSuspenseQueryError = void


export function useProductionPlannerControllerListPartnerProductionPlannerSuspense<TData = Awaited<ReturnType<typeof productionPlannerControllerListPartnerProductionPlanner>>, TError = void>(
 partnerId: string,
    params: undefined |  ProductionPlannerControllerListPartnerProductionPlannerParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof productionPlannerControllerListPartnerProductionPlanner>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useProductionPlannerControllerListPartnerProductionPlannerSuspense<TData = Awaited<ReturnType<typeof productionPlannerControllerListPartnerProductionPlanner>>, TError = void>(
 partnerId: string,
    params?: ProductionPlannerControllerListPartnerProductionPlannerParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof productionPlannerControllerListPartnerProductionPlanner>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useProductionPlannerControllerListPartnerProductionPlannerSuspense<TData = Awaited<ReturnType<typeof productionPlannerControllerListPartnerProductionPlanner>>, TError = void>(
 partnerId: string,
    params?: ProductionPlannerControllerListPartnerProductionPlannerParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof productionPlannerControllerListPartnerProductionPlanner>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Production planner: partner-wide work orders with tracking fields
 */

export function useProductionPlannerControllerListPartnerProductionPlannerSuspense<TData = Awaited<ReturnType<typeof productionPlannerControllerListPartnerProductionPlanner>>, TError = void>(
 partnerId: string,
    params?: ProductionPlannerControllerListPartnerProductionPlannerParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof productionPlannerControllerListPartnerProductionPlanner>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getProductionPlannerControllerListPartnerProductionPlannerSuspenseQueryOptions(partnerId,params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type productionPlanControllerGetCapacityMatrixResponse200 = {
  data: CapacityMatrixResponseDto
  status: 200
}

export type productionPlanControllerGetCapacityMatrixResponse400 = {
  data: void
  status: 400
}

export type productionPlanControllerGetCapacityMatrixResponse401 = {
  data: void
  status: 401
}

export type productionPlanControllerGetCapacityMatrixResponse403 = {
  data: void
  status: 403
}

export type productionPlanControllerGetCapacityMatrixResponse404 = {
  data: void
  status: 404
}

export type productionPlanControllerGetCapacityMatrixResponseSuccess = (productionPlanControllerGetCapacityMatrixResponse200) & {
  headers: Headers;
};
export type productionPlanControllerGetCapacityMatrixResponseError = (productionPlanControllerGetCapacityMatrixResponse400 | productionPlanControllerGetCapacityMatrixResponse401 | productionPlanControllerGetCapacityMatrixResponse403 | productionPlanControllerGetCapacityMatrixResponse404) & {
  headers: Headers;
};

export type productionPlanControllerGetCapacityMatrixResponse = (productionPlanControllerGetCapacityMatrixResponseSuccess | productionPlanControllerGetCapacityMatrixResponseError)

export const getProductionPlanControllerGetCapacityMatrixUrl = (partnerId: string,
    params: ProductionPlanControllerGetCapacityMatrixParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/partners/${partnerId}/production-plan/capacity-matrix?${stringifiedParams}` : `/partners/${partnerId}/production-plan/capacity-matrix`
}

/**
 * ENG-732 Capacity view feed. One row per partner factory (alphabetical), one cell per week-commencing date (partner first day of week) or per day in [from, to]. Each cell carries Throughput Demand (shift-hour apportioned, fractional), Actual Throughput, the effective Planned Throughput (manual week override beats baseline; day cells pro-rated by shift hours) and the engine utilisation band. Computed on read from the shift-hour engine — a null planned means no check exists (render an outline, never a colour). MVP metric: work_orders only.
 * @summary Multi-factory capacity matrix: demand vs planned per factory per week (or day)
 */
export const productionPlanControllerGetCapacityMatrix = async (partnerId: string,
    params: ProductionPlanControllerGetCapacityMatrixParams, options?: Parameters<typeof customFetch>[1]): Promise<productionPlanControllerGetCapacityMatrixResponse> => {

  return customFetch<productionPlanControllerGetCapacityMatrixResponse>(getProductionPlanControllerGetCapacityMatrixUrl(partnerId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getProductionPlanControllerGetCapacityMatrixQueryKey = (partnerId: string,
    params?: ProductionPlanControllerGetCapacityMatrixParams,) => {
    return [
    `/partners/${partnerId}/production-plan/capacity-matrix`, ...(params ? [params] : [])
    ] as const;
    }


export const getProductionPlanControllerGetCapacityMatrixQueryOptions = <TData = Awaited<ReturnType<typeof productionPlanControllerGetCapacityMatrix>>, TError = void>(partnerId: string,
    params: ProductionPlanControllerGetCapacityMatrixParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof productionPlanControllerGetCapacityMatrix>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getProductionPlanControllerGetCapacityMatrixQueryKey(partnerId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof productionPlanControllerGetCapacityMatrix>>> = ({ signal }) => productionPlanControllerGetCapacityMatrix(partnerId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: partnerId !== null && partnerId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof productionPlanControllerGetCapacityMatrix>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ProductionPlanControllerGetCapacityMatrixQueryResult = NonNullable<Awaited<ReturnType<typeof productionPlanControllerGetCapacityMatrix>>>
export type ProductionPlanControllerGetCapacityMatrixQueryError = void


export function useProductionPlanControllerGetCapacityMatrix<TData = Awaited<ReturnType<typeof productionPlanControllerGetCapacityMatrix>>, TError = void>(
 partnerId: string,
    params: ProductionPlanControllerGetCapacityMatrixParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof productionPlanControllerGetCapacityMatrix>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof productionPlanControllerGetCapacityMatrix>>,
          TError,
          Awaited<ReturnType<typeof productionPlanControllerGetCapacityMatrix>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useProductionPlanControllerGetCapacityMatrix<TData = Awaited<ReturnType<typeof productionPlanControllerGetCapacityMatrix>>, TError = void>(
 partnerId: string,
    params: ProductionPlanControllerGetCapacityMatrixParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof productionPlanControllerGetCapacityMatrix>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof productionPlanControllerGetCapacityMatrix>>,
          TError,
          Awaited<ReturnType<typeof productionPlanControllerGetCapacityMatrix>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useProductionPlanControllerGetCapacityMatrix<TData = Awaited<ReturnType<typeof productionPlanControllerGetCapacityMatrix>>, TError = void>(
 partnerId: string,
    params: ProductionPlanControllerGetCapacityMatrixParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof productionPlanControllerGetCapacityMatrix>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Multi-factory capacity matrix: demand vs planned per factory per week (or day)
 */

export function useProductionPlanControllerGetCapacityMatrix<TData = Awaited<ReturnType<typeof productionPlanControllerGetCapacityMatrix>>, TError = void>(
 partnerId: string,
    params: ProductionPlanControllerGetCapacityMatrixParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof productionPlanControllerGetCapacityMatrix>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getProductionPlanControllerGetCapacityMatrixQueryOptions(partnerId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Multi-factory capacity matrix: demand vs planned per factory per week (or day)
 */
export const prefetchProductionPlanControllerGetCapacityMatrixQuery = async <TData = Awaited<ReturnType<typeof productionPlanControllerGetCapacityMatrix>>, TError = void>(
 queryClient: QueryClient, partnerId: string,
    params: ProductionPlanControllerGetCapacityMatrixParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof productionPlanControllerGetCapacityMatrix>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getProductionPlanControllerGetCapacityMatrixQueryOptions(partnerId,params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}





export const getProductionPlanControllerGetCapacityMatrixSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof productionPlanControllerGetCapacityMatrix>>, TError = void>(partnerId: string,
    params: ProductionPlanControllerGetCapacityMatrixParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof productionPlanControllerGetCapacityMatrix>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getProductionPlanControllerGetCapacityMatrixQueryKey(partnerId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof productionPlanControllerGetCapacityMatrix>>> = ({ signal }) => productionPlanControllerGetCapacityMatrix(partnerId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof productionPlanControllerGetCapacityMatrix>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ProductionPlanControllerGetCapacityMatrixSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof productionPlanControllerGetCapacityMatrix>>>
export type ProductionPlanControllerGetCapacityMatrixSuspenseQueryError = void


export function useProductionPlanControllerGetCapacityMatrixSuspense<TData = Awaited<ReturnType<typeof productionPlanControllerGetCapacityMatrix>>, TError = void>(
 partnerId: string,
    params: ProductionPlanControllerGetCapacityMatrixParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof productionPlanControllerGetCapacityMatrix>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useProductionPlanControllerGetCapacityMatrixSuspense<TData = Awaited<ReturnType<typeof productionPlanControllerGetCapacityMatrix>>, TError = void>(
 partnerId: string,
    params: ProductionPlanControllerGetCapacityMatrixParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof productionPlanControllerGetCapacityMatrix>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useProductionPlanControllerGetCapacityMatrixSuspense<TData = Awaited<ReturnType<typeof productionPlanControllerGetCapacityMatrix>>, TError = void>(
 partnerId: string,
    params: ProductionPlanControllerGetCapacityMatrixParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof productionPlanControllerGetCapacityMatrix>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Multi-factory capacity matrix: demand vs planned per factory per week (or day)
 */

export function useProductionPlanControllerGetCapacityMatrixSuspense<TData = Awaited<ReturnType<typeof productionPlanControllerGetCapacityMatrix>>, TError = void>(
 partnerId: string,
    params: ProductionPlanControllerGetCapacityMatrixParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof productionPlanControllerGetCapacityMatrix>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getProductionPlanControllerGetCapacityMatrixSuspenseQueryOptions(partnerId,params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type productionPlanControllerGetSummaryResponse200 = {
  data: ProductionPlanSummaryResponseDto
  status: 200
}

export type productionPlanControllerGetSummaryResponse400 = {
  data: void
  status: 400
}

export type productionPlanControllerGetSummaryResponse401 = {
  data: void
  status: 401
}

export type productionPlanControllerGetSummaryResponse403 = {
  data: void
  status: 403
}

export type productionPlanControllerGetSummaryResponse404 = {
  data: void
  status: 404
}

export type productionPlanControllerGetSummaryResponseSuccess = (productionPlanControllerGetSummaryResponse200) & {
  headers: Headers;
};
export type productionPlanControllerGetSummaryResponseError = (productionPlanControllerGetSummaryResponse400 | productionPlanControllerGetSummaryResponse401 | productionPlanControllerGetSummaryResponse403 | productionPlanControllerGetSummaryResponse404) & {
  headers: Headers;
};

export type productionPlanControllerGetSummaryResponse = (productionPlanControllerGetSummaryResponseSuccess | productionPlanControllerGetSummaryResponseError)

export const getProductionPlanControllerGetSummaryUrl = (partnerId: string,
    params: ProductionPlanControllerGetSummaryParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["route_ids"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : String(v));
      });
      return;
    }

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/partners/${partnerId}/production-plan/summary?${stringifiedParams}` : `/partners/${partnerId}/production-plan/summary`
}

/**
 * Headline numbers for the Production Plan: planned, scheduled and actual throughput (ThroughputService rules, partner unit), the capacity checks for the week(s) the range covers, mean effective workload category and mean planned lead time over the work orders scheduled in range, at-risk work order count (throughput + labour passes) and the count of active work orders that cannot be forecast for missing scheduled dates. Optionally scoped to one factory; `route_ids` additionally scopes the three throughput figures only.
 * @summary Production plan summary for a partner over a date range
 */
export const productionPlanControllerGetSummary = async (partnerId: string,
    params: ProductionPlanControllerGetSummaryParams, options?: Parameters<typeof customFetch>[1]): Promise<productionPlanControllerGetSummaryResponse> => {

  return customFetch<productionPlanControllerGetSummaryResponse>(getProductionPlanControllerGetSummaryUrl(partnerId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getProductionPlanControllerGetSummaryQueryKey = (partnerId: string,
    params?: ProductionPlanControllerGetSummaryParams,) => {
    return [
    `/partners/${partnerId}/production-plan/summary`, ...(params ? [params] : [])
    ] as const;
    }


export const getProductionPlanControllerGetSummaryQueryOptions = <TData = Awaited<ReturnType<typeof productionPlanControllerGetSummary>>, TError = void>(partnerId: string,
    params: ProductionPlanControllerGetSummaryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof productionPlanControllerGetSummary>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getProductionPlanControllerGetSummaryQueryKey(partnerId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof productionPlanControllerGetSummary>>> = ({ signal }) => productionPlanControllerGetSummary(partnerId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: partnerId !== null && partnerId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof productionPlanControllerGetSummary>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ProductionPlanControllerGetSummaryQueryResult = NonNullable<Awaited<ReturnType<typeof productionPlanControllerGetSummary>>>
export type ProductionPlanControllerGetSummaryQueryError = void


export function useProductionPlanControllerGetSummary<TData = Awaited<ReturnType<typeof productionPlanControllerGetSummary>>, TError = void>(
 partnerId: string,
    params: ProductionPlanControllerGetSummaryParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof productionPlanControllerGetSummary>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof productionPlanControllerGetSummary>>,
          TError,
          Awaited<ReturnType<typeof productionPlanControllerGetSummary>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useProductionPlanControllerGetSummary<TData = Awaited<ReturnType<typeof productionPlanControllerGetSummary>>, TError = void>(
 partnerId: string,
    params: ProductionPlanControllerGetSummaryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof productionPlanControllerGetSummary>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof productionPlanControllerGetSummary>>,
          TError,
          Awaited<ReturnType<typeof productionPlanControllerGetSummary>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useProductionPlanControllerGetSummary<TData = Awaited<ReturnType<typeof productionPlanControllerGetSummary>>, TError = void>(
 partnerId: string,
    params: ProductionPlanControllerGetSummaryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof productionPlanControllerGetSummary>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Production plan summary for a partner over a date range
 */

export function useProductionPlanControllerGetSummary<TData = Awaited<ReturnType<typeof productionPlanControllerGetSummary>>, TError = void>(
 partnerId: string,
    params: ProductionPlanControllerGetSummaryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof productionPlanControllerGetSummary>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getProductionPlanControllerGetSummaryQueryOptions(partnerId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Production plan summary for a partner over a date range
 */
export const prefetchProductionPlanControllerGetSummaryQuery = async <TData = Awaited<ReturnType<typeof productionPlanControllerGetSummary>>, TError = void>(
 queryClient: QueryClient, partnerId: string,
    params: ProductionPlanControllerGetSummaryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof productionPlanControllerGetSummary>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getProductionPlanControllerGetSummaryQueryOptions(partnerId,params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}





export const getProductionPlanControllerGetSummarySuspenseQueryOptions = <TData = Awaited<ReturnType<typeof productionPlanControllerGetSummary>>, TError = void>(partnerId: string,
    params: ProductionPlanControllerGetSummaryParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof productionPlanControllerGetSummary>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getProductionPlanControllerGetSummaryQueryKey(partnerId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof productionPlanControllerGetSummary>>> = ({ signal }) => productionPlanControllerGetSummary(partnerId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof productionPlanControllerGetSummary>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ProductionPlanControllerGetSummarySuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof productionPlanControllerGetSummary>>>
export type ProductionPlanControllerGetSummarySuspenseQueryError = void


export function useProductionPlanControllerGetSummarySuspense<TData = Awaited<ReturnType<typeof productionPlanControllerGetSummary>>, TError = void>(
 partnerId: string,
    params: ProductionPlanControllerGetSummaryParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof productionPlanControllerGetSummary>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useProductionPlanControllerGetSummarySuspense<TData = Awaited<ReturnType<typeof productionPlanControllerGetSummary>>, TError = void>(
 partnerId: string,
    params: ProductionPlanControllerGetSummaryParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof productionPlanControllerGetSummary>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useProductionPlanControllerGetSummarySuspense<TData = Awaited<ReturnType<typeof productionPlanControllerGetSummary>>, TError = void>(
 partnerId: string,
    params: ProductionPlanControllerGetSummaryParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof productionPlanControllerGetSummary>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Production plan summary for a partner over a date range
 */

export function useProductionPlanControllerGetSummarySuspense<TData = Awaited<ReturnType<typeof productionPlanControllerGetSummary>>, TError = void>(
 partnerId: string,
    params: ProductionPlanControllerGetSummaryParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof productionPlanControllerGetSummary>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getProductionPlanControllerGetSummarySuspenseQueryOptions(partnerId,params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type productionPlanControllerGetWorkOrderPlanResponse200 = {
  data: WorkOrderPlanResponseDto
  status: 200
}

export type productionPlanControllerGetWorkOrderPlanResponse400 = {
  data: void
  status: 400
}

export type productionPlanControllerGetWorkOrderPlanResponse401 = {
  data: void
  status: 401
}

export type productionPlanControllerGetWorkOrderPlanResponse403 = {
  data: void
  status: 403
}

export type productionPlanControllerGetWorkOrderPlanResponse404 = {
  data: void
  status: 404
}

export type productionPlanControllerGetWorkOrderPlanResponseSuccess = (productionPlanControllerGetWorkOrderPlanResponse200) & {
  headers: Headers;
};
export type productionPlanControllerGetWorkOrderPlanResponseError = (productionPlanControllerGetWorkOrderPlanResponse400 | productionPlanControllerGetWorkOrderPlanResponse401 | productionPlanControllerGetWorkOrderPlanResponse403 | productionPlanControllerGetWorkOrderPlanResponse404) & {
  headers: Headers;
};

export type productionPlanControllerGetWorkOrderPlanResponse = (productionPlanControllerGetWorkOrderPlanResponseSuccess | productionPlanControllerGetWorkOrderPlanResponseError)

export const getProductionPlanControllerGetWorkOrderPlanUrl = (partnerId: string,
    workOrderId: string,) => {




  return `/partners/${partnerId}/production-plan/work-orders/${workOrderId}/plan`
}

/**
 * Computes Expected and Actual completion from the current scheduled window, factory-local clock and effective shift pattern. This is an on-demand read for the Plan cell tooltip; it does not persist or recalculate the rest of the factory.
 * @summary Live Plan status and tooltip detail for one work order
 */
export const productionPlanControllerGetWorkOrderPlan = async (partnerId: string,
    workOrderId: string, options?: Parameters<typeof customFetch>[1]): Promise<productionPlanControllerGetWorkOrderPlanResponse> => {

  return customFetch<productionPlanControllerGetWorkOrderPlanResponse>(getProductionPlanControllerGetWorkOrderPlanUrl(partnerId,workOrderId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getProductionPlanControllerGetWorkOrderPlanQueryKey = (partnerId: string,
    workOrderId: string,) => {
    return [
    `/partners/${partnerId}/production-plan/work-orders/${workOrderId}/plan`
    ] as const;
    }


export const getProductionPlanControllerGetWorkOrderPlanQueryOptions = <TData = Awaited<ReturnType<typeof productionPlanControllerGetWorkOrderPlan>>, TError = void>(partnerId: string,
    workOrderId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof productionPlanControllerGetWorkOrderPlan>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getProductionPlanControllerGetWorkOrderPlanQueryKey(partnerId,workOrderId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof productionPlanControllerGetWorkOrderPlan>>> = ({ signal }) => productionPlanControllerGetWorkOrderPlan(partnerId,workOrderId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: partnerId !== null && partnerId !== undefined && workOrderId !== null && workOrderId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof productionPlanControllerGetWorkOrderPlan>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ProductionPlanControllerGetWorkOrderPlanQueryResult = NonNullable<Awaited<ReturnType<typeof productionPlanControllerGetWorkOrderPlan>>>
export type ProductionPlanControllerGetWorkOrderPlanQueryError = void


export function useProductionPlanControllerGetWorkOrderPlan<TData = Awaited<ReturnType<typeof productionPlanControllerGetWorkOrderPlan>>, TError = void>(
 partnerId: string,
    workOrderId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof productionPlanControllerGetWorkOrderPlan>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof productionPlanControllerGetWorkOrderPlan>>,
          TError,
          Awaited<ReturnType<typeof productionPlanControllerGetWorkOrderPlan>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useProductionPlanControllerGetWorkOrderPlan<TData = Awaited<ReturnType<typeof productionPlanControllerGetWorkOrderPlan>>, TError = void>(
 partnerId: string,
    workOrderId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof productionPlanControllerGetWorkOrderPlan>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof productionPlanControllerGetWorkOrderPlan>>,
          TError,
          Awaited<ReturnType<typeof productionPlanControllerGetWorkOrderPlan>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useProductionPlanControllerGetWorkOrderPlan<TData = Awaited<ReturnType<typeof productionPlanControllerGetWorkOrderPlan>>, TError = void>(
 partnerId: string,
    workOrderId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof productionPlanControllerGetWorkOrderPlan>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Live Plan status and tooltip detail for one work order
 */

export function useProductionPlanControllerGetWorkOrderPlan<TData = Awaited<ReturnType<typeof productionPlanControllerGetWorkOrderPlan>>, TError = void>(
 partnerId: string,
    workOrderId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof productionPlanControllerGetWorkOrderPlan>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getProductionPlanControllerGetWorkOrderPlanQueryOptions(partnerId,workOrderId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Live Plan status and tooltip detail for one work order
 */
export const prefetchProductionPlanControllerGetWorkOrderPlanQuery = async <TData = Awaited<ReturnType<typeof productionPlanControllerGetWorkOrderPlan>>, TError = void>(
 queryClient: QueryClient, partnerId: string,
    workOrderId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof productionPlanControllerGetWorkOrderPlan>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getProductionPlanControllerGetWorkOrderPlanQueryOptions(partnerId,workOrderId,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}





export const getProductionPlanControllerGetWorkOrderPlanSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof productionPlanControllerGetWorkOrderPlan>>, TError = void>(partnerId: string,
    workOrderId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof productionPlanControllerGetWorkOrderPlan>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getProductionPlanControllerGetWorkOrderPlanQueryKey(partnerId,workOrderId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof productionPlanControllerGetWorkOrderPlan>>> = ({ signal }) => productionPlanControllerGetWorkOrderPlan(partnerId,workOrderId, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof productionPlanControllerGetWorkOrderPlan>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ProductionPlanControllerGetWorkOrderPlanSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof productionPlanControllerGetWorkOrderPlan>>>
export type ProductionPlanControllerGetWorkOrderPlanSuspenseQueryError = void


export function useProductionPlanControllerGetWorkOrderPlanSuspense<TData = Awaited<ReturnType<typeof productionPlanControllerGetWorkOrderPlan>>, TError = void>(
 partnerId: string,
    workOrderId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof productionPlanControllerGetWorkOrderPlan>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useProductionPlanControllerGetWorkOrderPlanSuspense<TData = Awaited<ReturnType<typeof productionPlanControllerGetWorkOrderPlan>>, TError = void>(
 partnerId: string,
    workOrderId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof productionPlanControllerGetWorkOrderPlan>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useProductionPlanControllerGetWorkOrderPlanSuspense<TData = Awaited<ReturnType<typeof productionPlanControllerGetWorkOrderPlan>>, TError = void>(
 partnerId: string,
    workOrderId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof productionPlanControllerGetWorkOrderPlan>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Live Plan status and tooltip detail for one work order
 */

export function useProductionPlanControllerGetWorkOrderPlanSuspense<TData = Awaited<ReturnType<typeof productionPlanControllerGetWorkOrderPlan>>, TError = void>(
 partnerId: string,
    workOrderId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof productionPlanControllerGetWorkOrderPlan>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getProductionPlanControllerGetWorkOrderPlanSuspenseQueryOptions(partnerId,workOrderId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type productionPlanControllerGetWorkOrderAtRiskReasonsResponse200 = {
  data: WorkOrderAtRiskReasonsResponseDto
  status: 200
}

export type productionPlanControllerGetWorkOrderAtRiskReasonsResponse401 = {
  data: void
  status: 401
}

export type productionPlanControllerGetWorkOrderAtRiskReasonsResponse403 = {
  data: void
  status: 403
}

export type productionPlanControllerGetWorkOrderAtRiskReasonsResponse404 = {
  data: void
  status: 404
}

export type productionPlanControllerGetWorkOrderAtRiskReasonsResponseSuccess = (productionPlanControllerGetWorkOrderAtRiskReasonsResponse200) & {
  headers: Headers;
};
export type productionPlanControllerGetWorkOrderAtRiskReasonsResponseError = (productionPlanControllerGetWorkOrderAtRiskReasonsResponse401 | productionPlanControllerGetWorkOrderAtRiskReasonsResponse403 | productionPlanControllerGetWorkOrderAtRiskReasonsResponse404) & {
  headers: Headers;
};

export type productionPlanControllerGetWorkOrderAtRiskReasonsResponse = (productionPlanControllerGetWorkOrderAtRiskReasonsResponseSuccess | productionPlanControllerGetWorkOrderAtRiskReasonsResponseError)

export const getProductionPlanControllerGetWorkOrderAtRiskReasonsUrl = (partnerId: string,
    workOrderId: string,) => {




  return `/partners/${partnerId}/production-plan/work-orders/${workOrderId}/at-risk-reasons`
}

/**
 * On-demand explanation for a single work order — fetched when the user asks "why", never per visible row. Throughput reasons are read from the persisted work_order_at_risk_reasons written by the recalc engine: one entry per check-week that flagged this row, naming the week, the check scope (factory-level or route), the metric, that check-week’s Planned Throughput / Throughput Demand / Available Capacity / Overage, this row’s own demand contribution, the cumulative total at the point the backwards walk pulled it in, and its position in that walk. Labour reasons are computed live from the Capacity Plan (they are not persisted): one entry per (operation, week) whose planned-labour shortfall flagged this row. Empty arrays with computed_at set mean "computed, not at risk"; computed_at null means this factory’s plan has never been computed — honest silence, never a fabricated zero.
 * @summary Why one work order is at risk: the check-weeks that flagged it, plus labour shortfalls
 */
export const productionPlanControllerGetWorkOrderAtRiskReasons = async (partnerId: string,
    workOrderId: string, options?: Parameters<typeof customFetch>[1]): Promise<productionPlanControllerGetWorkOrderAtRiskReasonsResponse> => {

  return customFetch<productionPlanControllerGetWorkOrderAtRiskReasonsResponse>(getProductionPlanControllerGetWorkOrderAtRiskReasonsUrl(partnerId,workOrderId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getProductionPlanControllerGetWorkOrderAtRiskReasonsQueryKey = (partnerId: string,
    workOrderId: string,) => {
    return [
    `/partners/${partnerId}/production-plan/work-orders/${workOrderId}/at-risk-reasons`
    ] as const;
    }


export const getProductionPlanControllerGetWorkOrderAtRiskReasonsQueryOptions = <TData = Awaited<ReturnType<typeof productionPlanControllerGetWorkOrderAtRiskReasons>>, TError = void>(partnerId: string,
    workOrderId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof productionPlanControllerGetWorkOrderAtRiskReasons>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getProductionPlanControllerGetWorkOrderAtRiskReasonsQueryKey(partnerId,workOrderId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof productionPlanControllerGetWorkOrderAtRiskReasons>>> = ({ signal }) => productionPlanControllerGetWorkOrderAtRiskReasons(partnerId,workOrderId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: partnerId !== null && partnerId !== undefined && workOrderId !== null && workOrderId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof productionPlanControllerGetWorkOrderAtRiskReasons>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ProductionPlanControllerGetWorkOrderAtRiskReasonsQueryResult = NonNullable<Awaited<ReturnType<typeof productionPlanControllerGetWorkOrderAtRiskReasons>>>
export type ProductionPlanControllerGetWorkOrderAtRiskReasonsQueryError = void


export function useProductionPlanControllerGetWorkOrderAtRiskReasons<TData = Awaited<ReturnType<typeof productionPlanControllerGetWorkOrderAtRiskReasons>>, TError = void>(
 partnerId: string,
    workOrderId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof productionPlanControllerGetWorkOrderAtRiskReasons>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof productionPlanControllerGetWorkOrderAtRiskReasons>>,
          TError,
          Awaited<ReturnType<typeof productionPlanControllerGetWorkOrderAtRiskReasons>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useProductionPlanControllerGetWorkOrderAtRiskReasons<TData = Awaited<ReturnType<typeof productionPlanControllerGetWorkOrderAtRiskReasons>>, TError = void>(
 partnerId: string,
    workOrderId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof productionPlanControllerGetWorkOrderAtRiskReasons>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof productionPlanControllerGetWorkOrderAtRiskReasons>>,
          TError,
          Awaited<ReturnType<typeof productionPlanControllerGetWorkOrderAtRiskReasons>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useProductionPlanControllerGetWorkOrderAtRiskReasons<TData = Awaited<ReturnType<typeof productionPlanControllerGetWorkOrderAtRiskReasons>>, TError = void>(
 partnerId: string,
    workOrderId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof productionPlanControllerGetWorkOrderAtRiskReasons>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Why one work order is at risk: the check-weeks that flagged it, plus labour shortfalls
 */

export function useProductionPlanControllerGetWorkOrderAtRiskReasons<TData = Awaited<ReturnType<typeof productionPlanControllerGetWorkOrderAtRiskReasons>>, TError = void>(
 partnerId: string,
    workOrderId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof productionPlanControllerGetWorkOrderAtRiskReasons>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getProductionPlanControllerGetWorkOrderAtRiskReasonsQueryOptions(partnerId,workOrderId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Why one work order is at risk: the check-weeks that flagged it, plus labour shortfalls
 */
export const prefetchProductionPlanControllerGetWorkOrderAtRiskReasonsQuery = async <TData = Awaited<ReturnType<typeof productionPlanControllerGetWorkOrderAtRiskReasons>>, TError = void>(
 queryClient: QueryClient, partnerId: string,
    workOrderId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof productionPlanControllerGetWorkOrderAtRiskReasons>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getProductionPlanControllerGetWorkOrderAtRiskReasonsQueryOptions(partnerId,workOrderId,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}





export const getProductionPlanControllerGetWorkOrderAtRiskReasonsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof productionPlanControllerGetWorkOrderAtRiskReasons>>, TError = void>(partnerId: string,
    workOrderId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof productionPlanControllerGetWorkOrderAtRiskReasons>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getProductionPlanControllerGetWorkOrderAtRiskReasonsQueryKey(partnerId,workOrderId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof productionPlanControllerGetWorkOrderAtRiskReasons>>> = ({ signal }) => productionPlanControllerGetWorkOrderAtRiskReasons(partnerId,workOrderId, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof productionPlanControllerGetWorkOrderAtRiskReasons>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ProductionPlanControllerGetWorkOrderAtRiskReasonsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof productionPlanControllerGetWorkOrderAtRiskReasons>>>
export type ProductionPlanControllerGetWorkOrderAtRiskReasonsSuspenseQueryError = void


export function useProductionPlanControllerGetWorkOrderAtRiskReasonsSuspense<TData = Awaited<ReturnType<typeof productionPlanControllerGetWorkOrderAtRiskReasons>>, TError = void>(
 partnerId: string,
    workOrderId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof productionPlanControllerGetWorkOrderAtRiskReasons>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useProductionPlanControllerGetWorkOrderAtRiskReasonsSuspense<TData = Awaited<ReturnType<typeof productionPlanControllerGetWorkOrderAtRiskReasons>>, TError = void>(
 partnerId: string,
    workOrderId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof productionPlanControllerGetWorkOrderAtRiskReasons>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useProductionPlanControllerGetWorkOrderAtRiskReasonsSuspense<TData = Awaited<ReturnType<typeof productionPlanControllerGetWorkOrderAtRiskReasons>>, TError = void>(
 partnerId: string,
    workOrderId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof productionPlanControllerGetWorkOrderAtRiskReasons>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Why one work order is at risk: the check-weeks that flagged it, plus labour shortfalls
 */

export function useProductionPlanControllerGetWorkOrderAtRiskReasonsSuspense<TData = Awaited<ReturnType<typeof productionPlanControllerGetWorkOrderAtRiskReasons>>, TError = void>(
 partnerId: string,
    workOrderId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof productionPlanControllerGetWorkOrderAtRiskReasons>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getProductionPlanControllerGetWorkOrderAtRiskReasonsSuspenseQueryOptions(partnerId,workOrderId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type productionPlanControllerPreviewRescheduleResponse200 = {
  data: RescheduleResponseDto
  status: 200
}

export type productionPlanControllerPreviewRescheduleResponse401 = {
  data: void
  status: 401
}

export type productionPlanControllerPreviewRescheduleResponse403 = {
  data: void
  status: 403
}

export type productionPlanControllerPreviewRescheduleResponse404 = {
  data: void
  status: 404
}

export type productionPlanControllerPreviewRescheduleResponse422 = {
  data: void
  status: 422
}

export type productionPlanControllerPreviewRescheduleResponseSuccess = (productionPlanControllerPreviewRescheduleResponse200) & {
  headers: Headers;
};
export type productionPlanControllerPreviewRescheduleResponseError = (productionPlanControllerPreviewRescheduleResponse401 | productionPlanControllerPreviewRescheduleResponse403 | productionPlanControllerPreviewRescheduleResponse404 | productionPlanControllerPreviewRescheduleResponse422) & {
  headers: Headers;
};

export type productionPlanControllerPreviewRescheduleResponse = (productionPlanControllerPreviewRescheduleResponseSuccess | productionPlanControllerPreviewRescheduleResponseError)

export const getProductionPlanControllerPreviewRescheduleUrl = (partnerId: string,) => {




  return `/partners/${partnerId}/production-plan/reschedule/preview`
}

/**
 * Computes the new scheduled windows and Manufacturing Sequence Numbers for moving the selected work orders so the earliest-starting one lands on first_start_date, preserving the selection's spacing and each work order's duration in WORKING days per the factory's shift pattern — nothing lands on a non-working day, and the block concertinas rather than leaving a hole where the weekend was. A factory with no shift pattern covering these dates keeps calendar-day spacing. Movers are resequenced to the end of their destination day. Pure preview — nothing is written.
 * @summary Preview a block-move reschedule (no writes)
 */
export const productionPlanControllerPreviewReschedule = async (partnerId: string,
    reschedulePreviewRequestDto: ReschedulePreviewRequestDto, options?: Parameters<typeof customFetch>[1]): Promise<productionPlanControllerPreviewRescheduleResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<productionPlanControllerPreviewRescheduleResponse>(getProductionPlanControllerPreviewRescheduleUrl(partnerId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(reschedulePreviewRequestDto)
  }
);}





export const getProductionPlanControllerPreviewRescheduleMutationKey = () => ['productionPlanControllerPreviewReschedule'] as const;

export const getProductionPlanControllerPreviewRescheduleMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof productionPlanControllerPreviewReschedule>>, TError,ProductionPlanControllerPreviewRescheduleMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof productionPlanControllerPreviewReschedule>>, TError,ProductionPlanControllerPreviewRescheduleMutationVariables, TContext> => {

const mutationKey = getProductionPlanControllerPreviewRescheduleMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof productionPlanControllerPreviewReschedule>>, ProductionPlanControllerPreviewRescheduleMutationVariables> = (props) => {
          const {partnerId,data} = props ?? {};

          return  productionPlanControllerPreviewReschedule(partnerId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ProductionPlanControllerPreviewRescheduleMutationResult = NonNullable<Awaited<ReturnType<typeof productionPlanControllerPreviewReschedule>>>
    export type ProductionPlanControllerPreviewRescheduleMutationBody = ReschedulePreviewRequestDto
    export type ProductionPlanControllerPreviewRescheduleMutationError = void
    export type ProductionPlanControllerPreviewRescheduleMutationVariables = {partnerId: string;data: ReschedulePreviewRequestDto}

    /**
 * @summary Preview a block-move reschedule (no writes)
 */
export const useProductionPlanControllerPreviewReschedule = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof productionPlanControllerPreviewReschedule>>, TError,ProductionPlanControllerPreviewRescheduleMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof productionPlanControllerPreviewReschedule>>,
        TError,
        ProductionPlanControllerPreviewRescheduleMutationVariables,
        TContext
      > => {
      return useMutation(getProductionPlanControllerPreviewRescheduleMutationOptions(options), queryClient);
    }
    export type productionPlanControllerApplyRescheduleResponse201 = {
  data: RescheduleResponseDto
  status: 201
}

export type productionPlanControllerApplyRescheduleResponse401 = {
  data: void
  status: 401
}

export type productionPlanControllerApplyRescheduleResponse403 = {
  data: void
  status: 403
}

export type productionPlanControllerApplyRescheduleResponse404 = {
  data: void
  status: 404
}

export type productionPlanControllerApplyRescheduleResponse422 = {
  data: void
  status: 422
}

export type productionPlanControllerApplyRescheduleResponseSuccess = (productionPlanControllerApplyRescheduleResponse201) & {
  headers: Headers;
};
export type productionPlanControllerApplyRescheduleResponseError = (productionPlanControllerApplyRescheduleResponse401 | productionPlanControllerApplyRescheduleResponse403 | productionPlanControllerApplyRescheduleResponse404 | productionPlanControllerApplyRescheduleResponse422) & {
  headers: Headers;
};

export type productionPlanControllerApplyRescheduleResponse = (productionPlanControllerApplyRescheduleResponseSuccess | productionPlanControllerApplyRescheduleResponseError)

export const getProductionPlanControllerApplyRescheduleUrl = (partnerId: string,) => {




  return `/partners/${partnerId}/production-plan/reschedule`
}

/**
 * Applies the same working-day computation as the preview in one transaction: scheduled start/complete move as date-anchored midnight UTC timestamps (shift slot references recompute via trigger) and every changed Manufacturing Sequence Number is written. Statuses are re-validated at apply time. Each affected work order is audited with the change tuples and the optional note.
 * @summary Apply a block-move reschedule
 */
export const productionPlanControllerApplyReschedule = async (partnerId: string,
    rescheduleApplyRequestDto: RescheduleApplyRequestDto, options?: Parameters<typeof customFetch>[1]): Promise<productionPlanControllerApplyRescheduleResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<productionPlanControllerApplyRescheduleResponse>(getProductionPlanControllerApplyRescheduleUrl(partnerId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(rescheduleApplyRequestDto)
  }
);}





export const getProductionPlanControllerApplyRescheduleMutationKey = () => ['productionPlanControllerApplyReschedule'] as const;

export const getProductionPlanControllerApplyRescheduleMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof productionPlanControllerApplyReschedule>>, TError,ProductionPlanControllerApplyRescheduleMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof productionPlanControllerApplyReschedule>>, TError,ProductionPlanControllerApplyRescheduleMutationVariables, TContext> => {

const mutationKey = getProductionPlanControllerApplyRescheduleMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof productionPlanControllerApplyReschedule>>, ProductionPlanControllerApplyRescheduleMutationVariables> = (props) => {
          const {partnerId,data} = props ?? {};

          return  productionPlanControllerApplyReschedule(partnerId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ProductionPlanControllerApplyRescheduleMutationResult = NonNullable<Awaited<ReturnType<typeof productionPlanControllerApplyReschedule>>>
    export type ProductionPlanControllerApplyRescheduleMutationBody = RescheduleApplyRequestDto
    export type ProductionPlanControllerApplyRescheduleMutationError = void
    export type ProductionPlanControllerApplyRescheduleMutationVariables = {partnerId: string;data: RescheduleApplyRequestDto}

    /**
 * @summary Apply a block-move reschedule
 */
export const useProductionPlanControllerApplyReschedule = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof productionPlanControllerApplyReschedule>>, TError,ProductionPlanControllerApplyRescheduleMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof productionPlanControllerApplyReschedule>>,
        TError,
        ProductionPlanControllerApplyRescheduleMutationVariables,
        TContext
      > => {
      return useMutation(getProductionPlanControllerApplyRescheduleMutationOptions(options), queryClient);
    }
